import { ModuleType, ObjectTypes } from '@fi-shared/types';

export class AccessRightFilterSettings {
    LoadSelectionFiltersForEditing: boolean;
    ShowAllTabs: boolean;
    ModuleType: ModuleType;
    ObjectType: ObjectTypes;
    //SelectionMode;
    constructor(
        moduleType: ModuleType,
        showAllTabs: boolean,
        loadSelectionFiltersForEditing: boolean,
        objectType: ObjectTypes,
    ) {
        this.ModuleType = moduleType;
        this.ShowAllTabs = showAllTabs;
        this.LoadSelectionFiltersForEditing = loadSelectionFiltersForEditing;
        this.ObjectType = objectType;
    }
}
